import axios from "axios";
import authHeader from "@/Api/AuthHeader";

const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async createCourseDisciplina(DataSubject) {
      return await axios.post(URL_API + "coursesubject", DataSubject, {
        headers: authHeader(),
      });
    },

    async listSubejects(data) {
      return await axios.get(
        URL_API + `coursesubject?page=${data.page}&search=${data.searchQuery}`,
        {
          headers: authHeader(),
        }
      );
    },

    getSubjects() {
      return new Promise((resolve, reject) => {
        axios
          .get(URL_API + "getAllSubject", { headers: authHeader() })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getCourses() {
      return new Promise((resolve, reject) => {
        axios
          .get(URL_API + "getAllCourses", { headers: authHeader() })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    viewSubject(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(URL_API + "disciplinas/" + id, { headers: authHeader() })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    updateSubject(ctx, dataSubject) {
      return new Promise((resolve, reject) => {
        axios
          .put(URL_API + "disciplinas/" + dataSubject.id, dataSubject.data, {
            headers: authHeader(),
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    deleteSubject(id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(URL_API + "coursesubject/" + id, { headers: authHeader() })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
